import { useTranslation } from "react-i18next";
import { ChevronDownIcon, GlobeRotateIcon } from "@digitalreality/ui-icons";
import { ContextMenu, Inline } from "@digitalreality/ui";
import { locales } from "../../Helpers/Constants";
import React from "react";

type LanguageSwitchProp = {
  hideCarret?: boolean;
};

const LanguageSwitch = ({ hideCarret }: LanguageSwitchProp) => {
  const { i18n } = useTranslation();

  return (
    <ContextMenu
      id="example-menu"
      IconButtonProps={{
        size: "large",
        children: (
          <Inline gap={2}>
            <GlobeRotateIcon fontSize="large" />
            {!hideCarret && <ChevronDownIcon />}
          </Inline>
        ),
      }}
      items={locales}
      onSelect={(id) => {
        i18n.changeLanguage(id);
        localStorage.setItem("language", id);
      }}
    />
  );
};

export default LanguageSwitch;
